import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Upload, message, Typography, Button, Select } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import localStorage from '../../../../utils/localStorage';
import { API_DOWNLOAD, IPAddress, MAXIMOASSET } from '../../../../commons/api';
import { StyledHomepage } from '../../../../commons/styles/layout';
import StyledTable from '../../../../commons/styles/table';

const { Option } = Select;

const ParameterMapping = () => {
  const [fileName, setFileName] = useState('');
  const [dataSource, setDataSource] = useState([]);
  const [type, setType] = useState('Device');

  useEffect(() => {
    getFile();
    getParameterMappingList();
  }, [type]);

  const getFile = () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');

    axios({
      method: 'GET',
      url: `${MAXIMOASSET.ParameterDownload}?SiteId=${siteId}&Type=${type}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    })
      .then((response) => {
        setFileName(response.data.file);
      })
      .catch(console.error);
  };

  const getParameterMappingList = () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');

    axios({
      method: 'GET',
      url: `${MAXIMOASSET.ParameterList}?SiteId=${siteId}&Type=${type}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    })
      .then((response) => {
        setDataSource(response.data);
      })
      .catch(console.error);
  };

  const beforeUpload = (file) => {
    const isLt2M = file.size / 1024 / 1024 < 10;
    const isCSV = file.type === 'text/csv' ||
      ['.csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel'].includes(file.type);

    if (!isCSV) message.error('You can only upload CSV file!');
    if (!isLt2M) message.error('CSV file must be smaller than 10MB!');

    return isCSV && isLt2M;
  };

  const handleChange = (info) => {
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
      getParameterMappingList();
      getFile();
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const ParameterColumn = [
    { title: 'Ams Parameter', dataIndex: 'AmsParam', key: 'AmsParam' },
    { title: 'Device', dataIndex: 'Device', key: 'Device' },
    { title: 'Parameter', dataIndex: 'Parameter', key: 'Parameter' },
    { title: 'Group', dataIndex: 'Group', key: 'Group' }
  ];

  const token = localStorage.get('accessToken');
  const Authorization = `Bearer ${token}`;
  const siteId = localStorage.get('currentSite');

  return (
    <StyledHomepage>
      {fileName ? (
        <a href={`${IPAddress.LOCAL}${API_DOWNLOAD.DownloadAMS}/${fileName}`}>
          <Button type="primary">
            <DownOutlined /> {fileName}
          </Button>
        </a>
      ) : (
        <Button>Error downloading file</Button>
      )}

      <Upload
        name="file"
        accept=".csv"
        action={`${MAXIMOASSET.ParameterUpload}?SiteId=${siteId}&Type=${type}`}
        headers={{ Authorization }}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        showUploadList={false}
      >
        <Button style={{ marginLeft: 8 }}>Upload CSV</Button>
      </Upload>

      <Select style={{ marginLeft: 8 }} value={type} onChange={(value) => setType(value)}>
        <Option value="Asset">Asset</Option>
        <Option value="Device">Device</Option>
      </Select>

      <div style={{ marginTop: '2%' }}>
        <Typography.Title level={5}>Asset List</Typography.Title>
        <StyledTable
          columns={ParameterColumn}
          size="small"
          pagination={dataSource.length > 10 ? { pageSize: 10 } : false}
          dataSource={dataSource}
          rowKey="AmsParam"
        />
      </div>
    </StyledHomepage>
  );
};

export default ParameterMapping;
